import Vue from 'vue'
import Router from "vue-router"
import Store from '@/store'

import NotFound from "@/view/NotFound.vue"
import Top from "@/view/Top.vue"
import Login from "@/view/Login.vue"
import Account from "@/view/Account.vue"
import Reservation from "@/view/Reservation.vue"
import Tel from "@/view/Tel.vue"
import MatchingPay from "@/view/MatchingPay.vue"
import FollowingStatus from "@/view/FollowingStatus.vue"
import CustomerList from "@/view/customer/List.vue"
import CustomerStaff from "@/view/customer/Staff.vue"
import CustomerForm from "@/view/customer/Form.vue"
import CustomerDetail from "@/view/customer/Detail.vue"
import CustomerHistory from "@/view/customer/History.vue"
import CustomerFileManager from "@/view/customer/FileManager.vue"
import CustomerClaimManager from "@/view/customer/ClaimManager.vue"
import CustomerMatching from "@/view/customer/Matching.vue"
import CustomerMatchingHistory from "@/view/customer/MatchingHistory.vue"
import Customer_countShop from "@/view/customer_count/Shop.vue"
import Customer_countCounselor from "@/view/customer_count/Counselor.vue"
import Customer_shiftMonth from "@/view/customer_shift/Month.vue"
import Alert from "@/view/alert/Main.vue"
import CustomerMatchingStatus from "@/view/customer/MatchingStatus"
import CustomerMatchingCheck from "@/view/customer/MatchingCheck"
import MatchingLedger from "@/view/MatchingLedger.vue"
import ImportantRule from './view/contract/ImportantRule.vue'
import ContractInput from './view/contract/ContractInput.vue'
import ContractReview from './view/contract/ContractReview.vue'
import ContractDetail from './view/contract/ContractDetail.vue'

Vue.use(Router)

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Top,
            name: 'top',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/matching-ledger',
            component: MatchingLedger,
            name: 'matching_ledger',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            component: Login,
            name: 'login',
        },
        {
            path: '/account',
            component: Account,
            name: 'account',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/reservation',
            component: Reservation,
            name: 'reservation',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/tel',
            component: Tel,
            name: 'tel',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/matching_pay',
            component: MatchingPay,
            name: 'matching_pay',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/following_status/list',
            component: FollowingStatus,
            name: 'following_status_list',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/list',
            component: CustomerList,
            name: 'customer_list',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/staff',
            component: CustomerStaff,
            name: 'customer_staff',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/add',
            component: CustomerForm,
            name: 'customer_add',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/edit/:id',
            component: CustomerForm,
            name: 'customer_edit',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:id',
            component: CustomerDetail,
            name: 'customer_detail',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/file-manager/:id',
            component: CustomerFileManager,
            name: 'customer_file_manager',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/claim-manager/:id',
            component: CustomerClaimManager,
            name: 'customer_claim_manager',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/history/:id',
            component: CustomerHistory,
            name: 'customer_history',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/matching/:id',
            component: CustomerMatching,
            name: 'customer_matching',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/matching_history/:id',
            component: CustomerMatchingHistory,
            name: 'customer_matching_history',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer_count/shop',
            component: Customer_countShop,
            name: 'customer_count_shop',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer_count/co',
            component: Customer_countCounselor,
            name: 'customer_count_co',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer_shift/month',
            component: Customer_shiftMonth,
            name: 'customer_shift_month',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/alert',
            component: Alert,
            name: 'alert',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/matching-status',
            component: CustomerMatchingStatus,
            name: 'CustomerMatchingStatus',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/matching-check',
            component: CustomerMatchingCheck,
            name: 'CustomerMatchingCheck',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:userId/contract/:courseId/rules',
            component: ImportantRule,
            name: 'customer_contract_rules',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:userId/contract/:courseId/contract-input',
            component: ContractInput,
            name: 'customer_contract_input',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:userId/contract/:tempContractId/review',
            component: ContractReview,
            name: 'customer_contract_review',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:userId/contract/:courseId',
            component: ContractDetail,
            name: 'customer_contract_detail',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            component: NotFound,
        }

    ]
});

router.beforeEach((to, from, next) => {
    if (to.path === '/logout') {
        Store.dispatch("reset")
        next({
            path: '/login',
        })
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!Store.isExpire()) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next();
        }
    } else if (to.matched.some(record => record.name === 'login') && Store.isExpire()) {
        next({
            path: '/',
        })
    } else {
        next();
    }
})

export default router
